import { useId } from '@fluentui/react-components';
import type { GroundingCommandBarTabProps } from '../GroundingCommandBarTab';

export function useGroundingCommandBarTabValue(value: GroundingCommandBarTabProps['value']): string {
  return useId('grounding-command-bar-tab-', value?.toString());
}
